import { usePlatform } from '@shared/platform'
import { WEDDING_BOT_PAYMENT_URL } from '@shared/config/routes'
import CourseLanding from './CourseLanding'

const WeddingLandingPage = () => {
  const platform = usePlatform()

  const handleBuyClick = () => {
    platform.openLink(WEDDING_BOT_PAYMENT_URL)
  }

  return (
    <div className="course-detail-page safe-area-inset">
      <CourseLanding onBuyClick={handleBuyClick} />
    </div>
  )
}

export default WeddingLandingPage
